// Options for 2.3 Változások (Section 2.3 - Changes)
export const VALTOZASOK_OPTIONS = {
    hu: [
    { value: "modositas_tortent", label: "Tantervi módosítás történt" },
    { value: "kapacitas_valtozott", label: "Oktatói kapacitás változott" },
    { value: "kornyezet_valtozott", label: "Külső környezet változott" },
    { value: "nem_tortent", label: "Nem történt változás" },
    { value: "valtozasok_egyeb", label: "Egyéb:" }
    ],
    en: [
    { value: "modositas_tortent", label: "Curriculum revision implemented" },
    { value: "kapacitas_valtozott", label: "Change in teaching staff capacity" },
    { value: "kornyezet_valtozott", label: "Change in the external environment" },
    { value: "nem_tortent", label: "No changes" },
    { value: "valtozasok_egyeb", label: "Other:" }
    ]
};

// Options for 2.4.a Nem STEM képzési területhez kapcsolódó képzések (AACSB)
export const NEM_STEM_KEPZESEK_OPTIONS = {
    hu: [
    { value: "rendszeres_meresek", label: "Rendszeres, strukturált mérések minden Learning Goals (LG) és Learning Objectives (LO) vonatkozásában" },
    { value: "reszleges_meresek", label: "Részleges mérések kiválasztott LG/LO elemekre" },
    { value: "hallgatoi_teljesitmenyek", label: "Az értékelés hallgatói teljesítményekhez kapcsolódó bizonyítékokon alapul (pl. tantárgyi értékelések, vizsgák, projektek)" },
    { value: "alumni_visszajelzesek", label: "Alumni-visszajelzések révén" },
    { value: "munkaadok_visszajelzesei", label: "Munkaadók és szakmai partnerek visszajelzései alapján" },
    { value: "szakdolgozatok_alapjan", label: "Szakdolgozatok és záróvizsgák elemzése alapján" },
    { value: "nincs_ertekeles", label: "Jelenleg még nem működik formalizált értékelési folyamat a Learning Goals és Learning Objectives vonatkozásában" },
    { value: "nemStemKepzesekEgyeb", label: "Egyéb:" }
    ],
    en: [
    { value: "rendszeres_meresek", label: "Regular, structured assessments covering all Learning Goals (LGs) and Learning Objectives (LOs)" },
    { value: "reszleges_meresek", label: "Partial assessments focusing on selected LG/LO elements" },
    { value: "hallgatoi_teljesitmenyek", label: "Assessment based on evidence of student performance (e.g. course assessments, examinations, projects)" },
    { value: "alumni_visszajelzesek", label: "Alumni feedback" },
    { value: "munkaadok_visszajelzesei", label: "Feedback from employers and professional partners" },
    { value: "szakdolgozatok_alapjan", label: "Analysis of theses and final examinations" },
    { value: "nincs_ertekeles", label: "No formalised assessment process currently in place for Learning Goals and Learning Objectives" },
    { value: "nemStemKepzesekEgyeb", label: "Other:" }
    ]
};

// Options for 2.4.b Műszaki, informatikai, agrár képzési területhez (STEM) kapcsolódó képzések (ABET)
export const STEM_KEPZESEK_OPTIONS = {
    hu: [
    { value: "strukturalt_meresek", label: "Rendszeres, strukturált mérések minden PEO/SO vonatkozásában" },
    { value: "reszleges_meresek_peo", label: "Részleges mérések kiválasztott PEO/SO elemekre" },
    { value: "eves_hallgatoi_teljesitmenyek", label: "Éves/féléves hallgatói teljesítmény-értékelés alapján" },
    { value: "alumni_felmeresek", label: "Alumni-felmérések révén" },
    { value: "munkaadoi_visszajelzesek", label: "Munkaadói visszajelzések alapján" },
    { value: "portfolio_ertekeles", label: "Portfólió-értékelés módszerével" },
    { value: "akkreditacios_meresek", label: "Külső akkreditációs mérések keretében" },
    { value: "zarovizsgak_alapjan", label: "Szakdolgozatok és záróvizsgák elemzése alapján" },
    { value: "nincs_meres", label: "Nincs formális mérés" },
    { value: "stemKepzesekEgyeb", label: "Egyéb:" }
    ],
    en: [
    { value: "strukturalt_meresek", label: "Regular, structured assessments covering all PEOs and SOs" },
    { value: "reszleges_meresek_peo", label: "Partial assessments focusing on selected PEO/SO elements" },
    { value: "eves_hallgatoi_teljesitmenyek", label: "Assessment based on annual or semester-based student performance evaluations" },
    { value: "alumni_felmeresek", label: "Alumni surveys" },
    { value: "munkaadoi_visszajelzesek", label: "Employer feedbacks" },
    { value: "portfolio_ertekeles", label: "Portfolio-based assessment" },
    { value: "akkreditacios_meresek", label: "Assessment conducted within the framework of external accreditation processes" },
    { value: "zarovizsgak_alapjan", label: "Analysis of theses and final examinations" },
    { value: "nincs_meres", label: "No formal assessment in place" },
    { value: "stemKepzesekEgyeb", label: "Other:" }
    ]
};